var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg15(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.663,
    height: 20.37,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.404 8.388a1.155 1.155 0 0 1-1.62 0l-5.06-5.05-7.983 7.971-.747-.713a3.396 3.396 0 0 1 0-4.801l4.8-4.801a3.396 3.396 0 0 1 4.801 0l5.809 5.797a1.128 1.128 0 0 1 0 1.597Zm.793-2.4a2.269 2.269 0 0 1 0 3.204c-1.438 1.438-2.956.249-3.205 0L9.735 4.934l-6.307 6.307a1.128 1.128 0 0 0 0 1.597 1.141 1.141 0 0 0 1.608 0l5.231-5.232.804.804-5.231 5.232a1.128 1.128 0 0 0 0 1.596 1.141 1.141 0 0 0 1.608 0l5.23-5.231.805.804-5.231 5.231a1.128 1.128 0 0 0 0 1.597 1.128 1.128 0 0 0 1.596 0l5.231-5.232.804.804-5.231 5.231a1.128 1.128 0 0 0 0 1.597 1.128 1.128 0 0 0 1.597 0l9.42-9.443a3.396 3.396 0 0 0 0-4.801L16.87.994a3.398 3.398 0 0 0-4.734-.068l5.062 5.061Z",
    fill: "#603f3f",
    fillRule: "evenodd",
    "data-name": "Tracciato 346"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg15);
export default __webpack_public_path__ + "static/media/15.85ccd51730e82933995f7c1504dd2d0c.svg";
export { ForwardRef as ReactComponent };